import { ProjectListFilters } from "../../documents/utils/types";

export function filtersToQueryString(data: ProjectListFilters): string {
    const params = new URLSearchParams();
    const statuses = data.statusOptions.filter(s => s.selected)
    const roles = data.myRoleOptions.filter(r => r.selected)

    if (data.date.from !== "all" && data.date.to !== "all") {
        params.append("dateFrom", new Date(data.date.from).toISOString());
        params.append("dateTo", new Date(data.date.to).toISOString());
    }

    if (statuses.length !== 0) {
        params.append("statuses", statuses.map(s => s.uniqueName).join(","));
    }

    if (roles.length !== 0) {
        params.append("roles", roles.map(r => r.uniqueName).join(","));
    }
    return params.toString()
}

export const defProjectFilters: ProjectListFilters = {
    date: { from: "all", to: "all" },
    statusOptions: [

        {
            uniqueName: "I",
            name: "_W trakcie",
            translationCode: "project-status-i",
            selected: false
        },
        {
            uniqueName: "H",
            name: "_Wstrzymany",
            translationCode: "project-status-h",
            selected: false
        },
        {
            uniqueName: "F",
            name: "_Zakończony",
            translationCode: "document-status-f",
            selected: false
        },
        {
            uniqueName: "F",
            name: "_Anulowany",
            translationCode: "project-status-c",
            selected: false
        }
    ],
    myRoleOptions: [
        {
            uniqueName: "MY",
            name: "_MY",
            translationCode: "filters-my-projects",
            checkOther: true,
            selected: false
        },
        {
            uniqueName: "M",
            name: "_Autor",
            translationCode: "project-role-manager",
            selected: false
        },
        {
            uniqueName: "C",
            name: "_Edytor",
            translationCode: "project-role-collaborator",
            selected: false
        },

        {
            uniqueName: "V",
            name: "_Obserwator",
            translationCode: "project-role-observer",
            selected: false
        },

    ]
}
